<template>
    <div class="promote-content">
        <div class="content-item">
            <div class="item-content">
                <div class="item-title">软文推广分值</div>
                <el-input class="item-input medium" ref="article_input" v-model="formData.article_promote_score"
                          placeholder="请输入分值" v-one-number></el-input>
                <span class="input-text">分</span>
            </div>
            <div class="item-content">
                <div class="item-title">短视频推广分值</div>
                <el-input class="item-input medium" ref="video_input" v-model="formData.video_promote_score"
                          placeholder="请输入分值" v-one-number></el-input>
                <span class="input-text">分</span>
            </div>
        </div>
        <div class="content-item">
            <div class="content-title">用户分析</div>
            <div class="item-content">
                <div class="item-title">年龄范围</div>
                <el-input class="item-input mini" ref="user_analysis_age_begin"
                          v-model="formData.user_analysis_age_begin"></el-input>
                <div class="divide"></div>
                <el-input class="item-input mini" ref="user_analysis_age_end"
                          v-model="formData.user_analysis_age_end"></el-input>
                <span class="input-text front">分值</span>
                <el-input class="item-input tiny" ref="user_analysis_age_score"
                          v-model="formData.user_analysis_age_score" v-one-number></el-input>
                <span class="input-text">分</span>
            </div>
            <div class="item-content">
                <div class="item-title">地域分布</div>
                <el-input class="item-input max" ref="user_analysis_region_distribution"
                          v-model="formData.user_analysis_region_distribution"
                          placeholder="多个地域用“#”分开"></el-input>
                <span class="input-text front">分值</span>
                <el-input class="item-input tiny" ref="user_analysis_region_distribution_score"
                          v-model="formData.user_analysis_region_distribution_score"
                          v-one-number></el-input>
                <span class="input-text">分</span>
            </div>
            <div class="item-content">
                <div class="item-title">性别比例</div>
                <span class="input-text sex">男</span>
                <el-input class="item-input sex" @input="GenderMale" ref="user_analysis_man_ratio"
                          v-model="formData.user_analysis_man_ratio"
                          v-one-number></el-input>
                <span class="input-text sex">女</span>
                <el-input class="item-input sex" @input="GenderFemale" ref="user_analysis_woman_ratio"
                          v-model="formData.user_analysis_woman_ratio"
                          v-one-number></el-input>
                <span class="input-text front">分值</span>
                <el-input class="item-input tiny" ref="user_analysis_gender_score"
                          v-model="formData.user_analysis_gender_score" v-one-number></el-input>
                <span class="input-text">分</span>
            </div>
            <div class="item-content">
                <div class="item-title">款式喜好</div>
                <el-input class="item-input max" ref="user_analysis_style_preference"
                          v-model="formData.user_analysis_style_preference"
                          placeholder="多个款式用“#”分开"></el-input>
                <span class="input-text front">分值</span>
                <el-input class="item-input tiny" ref="user_analysis_style_preference_score"
                          v-model="formData.user_analysis_style_preference_score"
                          v-one-number></el-input>
                <span class="input-text">分</span>
            </div>
        </div>
        <div class="content-item">
            <div class="content-title">数据分析</div>
            <div class="item-content">
                <div class="item-title">性别比例</div>
                <span class="input-text sex">男</span>
                <el-input class="item-input sex" ref="data_analysis_man_ratio" @input="GenderMan"
                          v-model="formData.data_analysis_man_ratio"
                          v-one-number></el-input>
                <span class="input-text sex">女</span>
                <el-input class="item-input sex" ref="data_analysis_woman_ratio" @input="GenderWoman"
                          v-model="formData.data_analysis_woman_ratio"
                          v-one-number></el-input>
            </div>
            <div class="item-content" v-for="(item,index) in formData.data_analysis_age" :key="index">
                <div class="item-title" v-if="index === 0">年龄范围</div>
                <div class="item-title" v-else></div>
                <el-input class="item-input mini" :ref="`age_begin_${index}`"
                          v-model="item.age_begin"></el-input>
                <div class="divide"></div>
                <el-input class="item-input mini" :ref="`age_end_${index}`" v-model="item.age_end"></el-input>
                <span class="input-text front">比例</span>
                <el-input class="item-input tiny" :ref="`data_analysis_age_ratio_${index}`"
                          @change="sumAll(formData.data_analysis_age,index)"
                          v-model="item.ratio" v-one-number></el-input>
                <span class="input-text">%</span>
            </div>
            <div class="item-content" v-for="(item,index) in formData.data_analysis_region_distribution">
                <div class="item-title" v-if="index === 0">地区分布</div>
                <div class="item-title" v-else></div>
                <el-input class="item-input max" :ref="`province_${index}`" v-model="item.province"
                          placeholder="请输入省份"></el-input>
                <span class="input-text front">比例</span>
                <el-input class="item-input tiny" :ref="`data_analysis_region_distribution_ratio_${index}`"
                          @change="sumAll(formData.data_analysis_region_distribution,index)"
                          v-model="item.ratio" v-one-number></el-input>
                <span class="input-text">%</span>
            </div>
            <div class="item-content" v-for="(item,index) in formData.data_analysis_style_preference">
                <div class="item-title" v-if="index === 0">款式偏好</div>
                <div class="item-title" v-else></div>
                <el-input class="item-input max" :ref="`style_${index}`" v-model="item.style"
                          placeholder="请输入款式"></el-input>
                <span class="input-text front">比例</span>
                <el-input class="item-input tiny" :ref="`data_analysis_style_preference_ratio_${index}`"
                          @change="sumAll(formData.data_analysis_style_preference,index)"
                          v-model="item.ratio"
                          v-one-number></el-input>
                <span class="input-text">%</span>
            </div>
        </div>
        <div class="content-item">
            <div class="content-title">上传素材</div>
            <div class="item-content">
                <el-button type="primary" plain onclick="uploadFile.click()">点击上传</el-button>
                <input class="file-upload-btn" ref="uploadFile" id="uploadFile" type="file"
                       accept="application/zip, .rar" title=""
                       @change="changeFile($event)">
                <span class="upload-text">文件支持格式为zip和rar，文件大小不超过1G</span>
            </div>
        </div>
        <div class="content-item">
            <div class="item-content">
                <div class="upload-file-list">
                    <div class="file-item" v-for="(item, index) in materialList">
                        <i class="iconfont">&#xe60b;</i>
                        <span class="file-name" :title="item.name">{{item.name}}</span>
                        <el-progress :percentage="percent" v-show="percent < 100"></el-progress>
                        <i class="iconfont finish-icon" v-show="percent == 100">&#xe654;</i>
                        <i class="iconfont del-icon" @click="delMaterial(item, index)">&#xe651;</i>
                    </div>
                </div>
            </div>
        </div>
        <div class="footer-wrapper">
            <el-button type="primary" @click="submit">保存</el-button>
            <el-button @click="reset">取消</el-button>
        </div>
    </div>
</template>

<script>
    import oneNumber from "../../../../directive/index";
    import Upload from '@/utils/slice_upload';
    import {
        uploadMaterial,
        SaveArticlePromote,
        operationProblemDelMaterial,
        mergeSlice,
        operationProblemOpDetail
    } from '@/utils/apis'

    export default {
        name: "softPromote",
        directives: {
            oneNumber
        },
        props: ['practiceForm'],
        data() {
            return {
                formData: {
                    user_analysis_man_ratio: '',
                    user_analysis_woman_ratio: '',
                    data_analysis_man_ratio: '',
                    data_analysis_woman_ratio: '',
                    data_analysis_age: [],
                    data_analysis_region_distribution: [],
                    data_analysis_style_preference: [],
                    material_file: []
                },
                //素材列表
                materialList: [],
                percent: 0,
                id: "",
                uploadInstance: null,
            }
        },
        created() {
            this.fillData();
            this.id = this.$route.query.id;
            if (this.id !== undefined) {
                this.getSoftPromotion()
            }
        },
        methods: {
            getSoftPromotion() {
                let param = {
                    id:this.id
                }
                operationProblemOpDetail(param).then((res) => {
                    this.materialList = res.data.material_file;
                    this.formData.material_file = res.data.material_file;
                    this.formData.user_analysis_man_ratio = res.data.user_analysis_man_ratio;
                    this.formData.user_analysis_woman_ratio = res.data.user_analysis_woman_ratio;
                    this.formData.data_analysis_man_ratio = res.data.data_analysis_man_ratio;
                    this.formData.data_analysis_woman_ratio = res.data.data_analysis_woman_ratio;
                    this.formData.data_analysis_age = res.data.data_analysis_age;
                    this.formData.data_analysis_region_distribution = res.data.data_analysis_region_distribution;
                    this.formData.data_analysis_style_preference = res.data.data_analysis_style_preference;
                    this.percent = 100;
                }).catch((err) => {
                    console.log(err);
                })
            },
            fillData() {
                for (let i = 0; i < 6; i++) {
                    let obj = {
                        age_begin: '',
                        age_end: '',
                        ratio: ''
                    }
                    this.formData.data_analysis_age.push(obj)
                }
                for (let i = 0; i < 10; i++) {
                    let obj = {
                        province: '',
                        ratio: ''
                    }
                    this.formData.data_analysis_region_distribution.push(obj)
                }
                for (let i = 0; i < 10; i++) {
                    let obj = {
                        style: '',
                        ratio: ''
                    }
                    this.formData.data_analysis_style_preference.push(obj)
                }
            },
            submit() {
                let isErrNum = 0;
                if (!this.formData.article_promote_score) {
                    this.$refs.article_input.$el.classList.add('isError');
                    isErrNum = 1;
                } else {
                    this.$refs.article_input.$el.classList.remove('isError');
                }
                if (!this.formData.video_promote_score) {
                    this.$refs.video_input.$el.classList.add('isError');
                    isErrNum = 1;
                } else {
                    this.$refs.video_input.$el.classList.remove('isError');
                }
                if (!this.formData.user_analysis_age_begin) {
                    this.$refs.user_analysis_age_begin.$el.classList.add('isError');
                    isErrNum = 1;
                } else {
                    this.$refs.user_analysis_age_begin.$el.classList.remove('isError');
                }
                if (!this.formData.user_analysis_age_end) {
                    this.$refs.user_analysis_age_end.$el.classList.add('isError');
                    isErrNum = 1;
                } else {
                    this.$refs.user_analysis_age_end.$el.classList.remove('isError');
                }
                if (!this.formData.user_analysis_age_score) {
                    this.$refs.user_analysis_age_score.$el.classList.add('isError');
                    isErrNum = 1;
                } else {
                    this.$refs.user_analysis_age_score.$el.classList.remove('isError');
                }
                if (!this.formData.user_analysis_region_distribution) {
                    this.$refs.user_analysis_region_distribution.$el.classList.add('isError');
                    isErrNum = 1;
                } else {
                    this.$refs.user_analysis_region_distribution.$el.classList.remove('isError');
                }
                if (!this.formData.user_analysis_region_distribution_score) {
                    this.$refs.user_analysis_region_distribution_score.$el.classList.add('isError');
                    isErrNum = 1;
                } else {
                    this.$refs.user_analysis_region_distribution_score.$el.classList.remove('isError');
                }
                if (this.formData.user_analysis_man_ratio == '') {
                    this.$refs.user_analysis_man_ratio.$el.classList.add('isError');
                    isErrNum = 1;
                } else {
                    this.$refs.user_analysis_man_ratio.$el.classList.remove('isError');
                }
                if (this.formData.user_analysis_woman_ratio == '') {
                    this.$refs.user_analysis_woman_ratio.$el.classList.add('isError');
                    isErrNum = 1;
                } else {
                    this.$refs.user_analysis_woman_ratio.$el.classList.remove('isError');
                }
                if (!this.formData.user_analysis_gender_score) {
                    this.$refs.user_analysis_gender_score.$el.classList.add('isError');
                    isErrNum = 1;
                } else {
                    this.$refs.user_analysis_gender_score.$el.classList.remove('isError');
                }
                if (!this.formData.user_analysis_style_preference) {
                    this.$refs.user_analysis_style_preference.$el.classList.add('isError');
                    isErrNum = 1;
                } else {
                    this.$refs.user_analysis_style_preference.$el.classList.remove('isError');
                }
                if (!this.formData.user_analysis_style_preference_score) {
                    this.$refs.user_analysis_style_preference_score.$el.classList.add('isError');
                    isErrNum = 1;
                } else {
                    this.$refs.user_analysis_style_preference_score.$el.classList.remove('isError');
                }
                if (this.formData.data_analysis_man_ratio == '') {
                    this.$refs.data_analysis_man_ratio.$el.classList.add('isError');
                    isErrNum = 1;
                } else {
                    this.$refs.data_analysis_man_ratio.$el.classList.remove('isError');
                }
                if (this.formData.data_analysis_woman_ratio == '') {
                    this.$refs.data_analysis_woman_ratio.$el.classList.add('isError');
                    isErrNum = 1;
                } else {
                    this.$refs.data_analysis_woman_ratio.$el.classList.remove('isError');
                }
                this.formData.data_analysis_age.forEach((item, index) => {
                    if (item.age_begin == '') {
                        this.$refs[`age_begin_${index}`][0].$el.classList.add('isError');
                        isErrNum = 1;
                    } else {
                        this.$refs[`age_begin_${index}`][0].$el.classList.remove('isError');
                    }
                    if (item.age_end == '') {
                        this.$refs[`age_end_${index}`][0].$el.classList.add('isError');
                        isErrNum = 1;
                    } else {
                        this.$refs[`age_end_${index}`][0].$el.classList.remove('isError');
                    }
                    if (item.ratio == '') {
                        this.$refs[`data_analysis_age_ratio_${index}`][0].$el.classList.add('isError');
                        isErrNum = 1;
                    } else {
                        this.$refs[`data_analysis_age_ratio_${index}`][0].$el.classList.remove('isError');
                    }
                })
                this.formData.data_analysis_region_distribution.forEach((item, index) => {
                    if (item.province == '') {
                        this.$refs[`province_${index}`][0].$el.classList.add('isError');
                        isErrNum = 1;
                    } else {
                        this.$refs[`province_${index}`][0].$el.classList.remove('isError');
                    }
                    if (item.ratio == '') {
                        this.$refs[`data_analysis_region_distribution_ratio_${index}`][0].$el.classList.add('isError');
                        isErrNum = 1;
                    } else {
                        this.$refs[`data_analysis_region_distribution_ratio_${index}`][0].$el.classList.remove('isError');
                    }
                })
                this.formData.data_analysis_style_preference.forEach((item, index) => {
                    if (item.style == '') {
                        this.$refs[`style_${index}`][0].$el.classList.add('isError');
                        isErrNum = 1;
                    } else {
                        this.$refs[`style_${index}`][0].$el.classList.remove('isError');
                    }
                    if (item.ratio == '') {
                        this.$refs[`data_analysis_style_preference_ratio_${index}`][0].$el.classList.add('isError');
                        isErrNum = 1;
                    } else {
                        this.$refs[`data_analysis_style_preference_ratio_${index}`][0].$el.classList.remove('isError');
                    }
                })
                if (this.formData.material_file.length === 0) {
                    this.$message.warning('请上传素材！');
                    isErrNum = 1;
                }
                if (!this.practiceForm.name) {
                    this.$message.warning('请填写名称！');
                    isErrNum = 1;
                }
                if (this.practiceForm.classValue.length === 0) {
                    this.$message.warning('请选择分类！');
                    isErrNum = 1;
                }
                if (this.practiceForm.taskList.length === 0) {
                    this.$message.warning('请添加任务目标！');
                    isErrNum = 1;
                }
                if (!this.practiceForm.taskBackground) {
                    this.$message.warning('请填写任务背景！');
                    isErrNum = 1;
                }
                if (!this.practiceForm.taskAnalysis) {
                    this.$message.warning('请填写任务分析！');
                    isErrNum = 1;
                }
                if (!this.practiceForm.taskOperation) {
                    this.$message.warning('请填写任务操作！');
                    isErrNum = 1;
                }
                if (this.practiceForm.scoreList.length === 0) {
                    this.$message.warning('请添加评分标准！');
                    isErrNum = 1;
                }
                if (isErrNum === 0) {
                    this.formData.op_name = this.practiceForm.name
                    this.formData.exam_module_id = this.practiceForm.module_level_three_value
                    this.formData.assess_time = this.practiceForm.time
                    this.formData.task_goal = this.practiceForm.taskList
                    this.formData.task_background = this.practiceForm.taskBackground
                    this.formData.task_analysis = this.practiceForm.taskAnalysis
                    this.formData.task_operation = this.practiceForm.taskOperation
                    this.formData.scoring_criteria = this.practiceForm.scoreList
                    this.formData.category_id = this.practiceForm.classValue[this.practiceForm.classValue.length - 1]
                    if (this.practiceForm.id != null) {
                        this.formData.id = this.practiceForm.id
                    }
                    SaveArticlePromote(this.formData).then((res) => {
                        if (res.code == 200) {
                            this.$message.success(res.msg);
                            this.reset()
                        } else {
                            this.$message.warning(res.msg)
                        }
                    }).catch((err) => {
                        console.log('err', err)
                    })
                } else {
                    this.$message.warning('每项为必填！')
                }
            },
            reset() {
                this.formData.user_analysis_man_ratio = '';
                this.formData.user_analysis_woman_ratio = '';
                this.formData.data_analysis_man_ratio = '';
                this.formData.data_analysis_woman_ratio = '';
                this.formData.data_analysis_age = '';
                this.formData.data_analysis_region_distribution = '';
                this.formData.data_analysis_style_preference = '';
                this.formData.material_file = '';
            },
            GenderMale() {
                if (this.formData.user_analysis_man_ratio > 100) {
                    this.formData.user_analysis_man_ratio = 100
                }
                this.formData.user_analysis_woman_ratio = (100 - this.formData.user_analysis_man_ratio).toFixed(1)
            },
            GenderFemale() {
                if (this.formData.user_analysis_woman_ratio > 100) {
                    this.formData.user_analysis_woman_ratio = 100
                }
                this.formData.user_analysis_man_ratio = (100 - this.formData.user_analysis_woman_ratio).toFixed(1)
            },
            GenderMan() {
                if (this.formData.data_analysis_man_ratio > 100) {
                    this.formData.data_analysis_man_ratio = 100
                }
                this.formData.data_analysis_woman_ratio = (100 - this.formData.data_analysis_man_ratio).toFixed(1)

            },
            GenderWoman() {
                if (this.formData.data_analysis_woman_ratio > 100) {
                    this.formData.data_analysis_woman_ratio = 100
                }
                this.formData.data_analysis_man_ratio = (100 - this.formData.data_analysis_woman_ratio).toFixed(1)
            },
            sumAll(arr, index) {
                if (arr[index].ratio > 100) {
                    arr[index].ratio = 100
                }
                let len = arr.length
                let sum = 0, value = 0;
                for (let i = 0; i < len; i++) {
                    if (arr[i].ratio != '') {
                        sum += Number(arr[i].ratio);
                        value++;
                    }
                    if (arr[index].ratio == 100) {
                        if (i !== index) {
                            arr[i].ratio = 0
                        }
                    }
                }
                if (sum > 100) {
                    arr[index].ratio = 0
                    this.$message.warning('范围比例不能超过100！')
                }
                if (value == len - 1 && sum < 100) {
                    for (let i = 0; i < len; i++) {
                        if (arr[i].ratio == '') {
                            arr[i].ratio = (100 - sum)
                        }
                    }
                }
                if (value == len && sum < 100) {
                    sum = sum - arr[index].ratio;
                    arr[index].ratio = (100 - sum)
                }
            },
            changeFile(event) {
                let chunkSize = 1024 * 1024 * 5;
                let file = event.target.files[0];
                this.uploadInstance = new Upload(file, chunkSize, uploadMaterial);
                let obj = {
                    name: file.name,
                    url: ''
                }
                this.materialList = []
                this.formData.material_file = [];
                this.materialList.push(obj);
                this.formData.material_file.push(obj);
                let index = 0;
                this.uploadSlice(index);
            },
            uploadSlice(index) {
                let num = this.uploadInstance.total_block_num;
                if (index === num && num !== 1) {
                    //合并分片
                    mergeSlice({
                        flag: this.uploadInstance.file_tmp,
                        slice_size: this.uploadInstance.block_size
                    }).then(res => {
                        if (res.code === 200) {
                            this.percent = 100;
                            this.formData.material_file[0].url = res.data.src
                            this.materialList[0].url = res.data.src
                            this.$refs.uploadFile.value = null
                            this.$message.success(res.msg);
                        }
                    });
                    return;
                }
                this.uploadInstance.uploadSlice(index).then(res => {
                    if (res.code === 200) {
                        if (res.data.is_slice) { //is_slice 为true则为分片上传，后面需要合并分片,若为false则无须分片，或者文件大小<分片尺寸，直接上传就行
                            this.percent = Math.ceil((index / num) * 100);
                            this.uploadSlice(++index);
                        } else {
                            this.percent = 100;
                            this.formData.material_file[0].url = res.data.src
                            this.materialList[0].url = res.data.src
                            this.$refs.uploadFile.value = null
                            this.$message.success(res.msg);
                        }
                    }
                });
            },
            //删除素材
            delMaterial(item, index) {
                this.$confirm('是否删除', '提示消息', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    customClass: 'green-message-box',
                    type: 'warning'
                }).then(() => {
                    let param = {
                        file_url: item.url
                    }
                    operationProblemDelMaterial(param).then((res) => {
                        if (res.code == 200) {
                            this.$message.success(res.msg);
                            this.formData.material_file.splice(index, 1);
                            this.materialList.splice(index, 1);
                        }
                    }).catch((err) => {
                        console.log(err);
                    })
                }).catch(() => {
                    this.$message.error('已取消删除');
                })
            },
        }
    }
</script>

<style scoped lang="scss">
    .promote-content {
        margin-top: 20px;
        font-size: 16px;
        color: #333333;

        .item-input {
            &.max {
                width: 360px;
            }

            &.medium {
                width: 250px;
            }

            &.mini {
                width: 150px;
            }

            &.sex {
                width: 130px;
            }

            &.tiny {
                width: 120px;
            }
        }

        .input-text {
            margin: 0 10px;

            &.sex {
                margin: 0 17px;
            }

            &.front {
                margin: 0 12px 0 22px;
            }
        }

        .content-item {

            .content-title {
                position: relative;
                padding-left: 10px;
                margin-bottom: 22px;

                &:before {
                    content: '';
                    width: 4px;
                    height: 16px;
                    background-color: #2DC079;
                    border-radius: 2px;
                    position: absolute;
                    left: 0;
                    top: 3px;
                }
            }

            .item-content {
                display: flex;
                align-items: center;
                margin-bottom: 16px;

                .item-title {
                    width: 120px;
                    text-align: right;
                    margin-right: 10px;
                }

                .divide {
                    width: 24px;
                    height: 2px;
                    background: #D2D2D2;
                    margin: 0 18px;
                }

                .file-upload-btn {
                    display: none;
                }

                .upload-text {
                    margin-left: 11px;
                    font-size: 14px;
                    color: #999999;
                }

                .upload-file-list {
                    display: flex;
                    flex-wrap: wrap;
                    margin-top: 20px;

                    .file-item {
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        height: 40px;
                        padding: 10px;
                        box-sizing: border-box;
                        color: #333333;
                        font-size: 14px;
                        margin: 0 20px 15px 0;

                        &:hover {
                            cursor: pointer;
                            background-color: #F5F7FA;

                            .del-icon {
                                display: block;
                            }

                            .finish-icon {
                                display: none;
                            }
                        }

                        .file-name {
                            display: inline-block;
                            width: 1%;
                            flex: 1;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                        }

                        .el-progress {
                            margin-left: 20px;
                            width: 160px;
                        }

                        i {
                            color: #2461EF;
                            margin: 0 10px 0 0;
                        }

                        .finish-icon {
                            color: #2DC079;
                            margin: 0 0 0 10px;
                        }

                        .del-icon {
                            display: none;
                            color: #FF0000;
                            margin: 0 0 0 10px;
                        }
                    }
                }
            }

        }

        .footer-wrapper {
            text-align: center;
            margin-top: 50px;
        }
    }
</style>